import React, { useState, useEffect } from "react";
import { useAppContext } from "../../../../../../AppContext";
import axios from "axios";
import Window from "../../../../elements/window";
import Slide1 from "./slides/slide1";
import Slide2 from "./slides/slide2";
import Slide3 from "./slides/slide3";
import Loader from "../../../../../settings/loader";
import { exportPdf } from "../../../../../exportPdf";
import "./style.scss";

function DeviceAnalytics(props) {
  const { user, chimeraserv } = useAppContext();
  const [data, setData] = useState({
    result: null,
    state: false,
  });
  const [load, setLoad] = useState(0);
  const [exportData, setExportData] = useState(null);
  const [triggerExport, setTriggerExport] = useState(false);

  useEffect(() => {
    async function fetchDeviceStats() {
      try {
        const headers = {
          Authorization: user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        };

        // Fetch user list first
        const userResponse = await axios.get(chimeraserv.urlGet + "/user", {
          headers,
        });

        let users = [];
        if (Object.keys(userResponse.data).length) {
          users = userResponse.data;
        }

        // Create a map of userId to user details for quick lookup
        const userMap = {};
        users.forEach((usr) => {
          userMap[usr._id] = {
            name: usr.name || usr.username || "Unknown User",
            email: usr.email || "N/A",
            usrKey: usr.usrKey,
          };
        });

        // Fetch login details
        const response = await fetch(`${chimeraserv.urlGet}/login-details`, {
          headers: new Headers(headers),
        });
        const result = await response.json();

        if (result.success) {
          setData({
            result: {
              loginDetails: result.data,
              statistics: result.statistics,
              userMap: userMap,
            },
            state: true,
          });
          setLoad(1);
        }
      } catch (error) {
        console.error("Error fetching device stats:", error);
        setLoad(1);
      }
    }

    if (!load) {
      fetchDeviceStats();
    }
  }, [user, chimeraserv, load]);

  const handleExport = () => {
    setTriggerExport(true);
  };

  const handleGetData = (data) => {
    if (data) {
      exportPdf.table(data);
    }
    setTriggerExport(false);
  };

  return (
    <div className="device-analytics-view">
      <div className="view-header">
        <div className="viewTitle">Device Usage Analytics</div>

        {/* <button className="export-button" onClick={handleExport}>
          Export Report
        </button> */}
      </div>

      {!load ? (
        <Loader />
      ) : (
        <>
          <Slide1 data={data} />
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Device Usage Statistics"}
            horizontal
          >
            <Slide2 data={data} />
          </Window>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"User vs Device Usage Statistics"}
            horizontal
          >
            <Slide3
              data={data}
              export={triggerExport}
              getData={handleGetData}
            />
          </Window>
        </>
      )}
    </div>
  );
}

export default DeviceAnalytics;
